var alertTriggersList = {
	caption: "Elenco di Trigger Avvisi",
	noResultsMessage: "Nessun risultato trovato",
	actions: "Azioni",
	trigger: {
		dateTime: "Data di creazione",
		limits: "Limiti",
		limitAbove: "Upper limit",
		limitBelow: "Lower limit"
	},
	security: {
		name: "Nome",
		isin: "ISIN",
		lastPrice: "Ultimo prezzo",
		lastPriceDateTime: "Data/Ora",
		assetClass: "Asset class",
		exchange: "Mercato"
	}
};
var it = {
	alertTriggersList: alertTriggersList
};

export { alertTriggersList, it as default };
